import { WorkHistoryIcon } from '@hugeicons/core-free-icons';
import { History } from 'views/Check/tabs/History/History';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';

import { useGetCandidateChecksQuery } from 'api/candidates-api';

export const CandidateHistory = ({
  candidate,
  company,
  referees,
  user,
  companyChecks,
  show = false,
  onClose = () => {},
}) => {
  const { data: checks = [] } = useGetCandidateChecksQuery(candidate?.id, {
    skip: !show || !candidate?.id,
    refetchOnMountOrArgChange: true,
  });

  return (
    show &&
    candidate && (
      <AnimatedModal
        visible={show}
        onClose={onClose}
        icon={WorkHistoryIcon}
        oldIconLibrary={false}
        title={`${candidate?.name} history`}
        className="readonly-modal"
        fullscreen={false}>
        <History
          key={candidate.id}
          company={company}
          candidate={candidate}
          referees={referees}
          user={user}
          companyChecks={companyChecks}
          checks={checks}
          readOnly
        />
      </AnimatedModal>
    )
  );
};
